module.exports = __webpack_public_path__ + "fb4644a096cc5cc29bd336319b506421.png";